import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';

export class CustomUrlSerializer implements UrlSerializer {
  private defaultSerializer = new DefaultUrlSerializer();

  parse(url: string): UrlTree {
    // only touch the path part, not the query string or fragment
    const index = url.search(/[?#]/);
    const path = index === -1 ? url : url.substring(0, index);
    const rest = index === -1 ? '' : url.substring(index);

    const fixedPath = path.replace(/\/RE=/g, '/RE%3D');
    return this.defaultSerializer.parse(fixedPath + rest);
  }

  serialize(tree: UrlTree): string {
    return this.defaultSerializer.serialize(tree).replace(/\/RE%3D/g, '/RE=');
  }
}